import React, { useState, useEffect, useRef } from "react";
import { auth } from "../../utils/auth";
import { withRequest } from "../../utils/request";
import ImageLoader from "../general/ImageLoader";
import Precios from "./Precios";
import SelectAsync from "react-select/async";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from "react-select/async-creatable";
import { getSuplidoresForDropdown, getUbicacionesForDropdown } from "../../utils/helpers";
import { catalogoUnidadesCompleto, crearUnidadConfig } from "../../utils/unidades";
import { crearAlmacen, crearUbicacion, textoCrear } from "../../utils/almacenesUbicaciones";
import Componente from "./Componente";
import Seccion, { ErrorCampo } from "../general/Seccion";
import Presentaciones from "./Presentaciones";
import CategoriasCheckboxTree from "../general/CategoriasCheckboxTree";
import {
	categoriasDeProducto,
	gruposDeRespuesta,
	idsDeCategorias,
} from "../../utils/categorias";

// [valor, etiqueta, icono, descripción]
const TIPOS = [
	["producto", "Producto", "fas fa-box-open", "Artículo físico"],
	["servicio", "Servicio", "fas fa-concierge-bell", "Trabajo o tarifa"],
	["grupo", "Grupo", "fas fa-cubes", "Kit de productos"],
];

const Form = ({ producto, errors, request }) => {
	const [arbolGrupos, setArbolGrupos] = useState([]);
	const [categorias, setCategorias] = useState(
		idsDeCategorias(categoriasDeProducto(producto))
	);
	const [almacenes, setAlmacenes] = useState([]);
	const [inventariable, setInventariable] = useState(true);
	const [cantidad, setCantidad] = useState(null);
	const [paquetesIniciales, setPaquetesIniciales] = useState("");
	const [unidadesIniciales, setUnidadesIniciales] = useState("");
	const [precios_venta, setPreciosVenta] = useState([
		{
			id: Date.now(),
			precio_venta: 0,
			impuesto: 0,
			precio_total: 0,
			costo: 0,
		},
	]);
	const [productoType, setProductoType] = useState("producto");
	const [impuesto_id, setImpuestoId] = useState("");
	const [impuestos, setImpuestos] = useState([]);
	const [costo_total, setCostoTotal] = useState(0);
	const [costo, setCosto] = useState(0);
	const [unidades, setUnidades] = useState([]);
	const [unidad, setUnidad] = useState({ value: "UND", label: "UND" });
	const [empaque, setEmpaque] = useState(null);
	const [cantidadEmpaque, setCantidadEmpaque] = useState("");
	const [costoPor, setCostoPor] = useState("unidad");
	const [isLoading, setIsLoading] = useState(false);
	const [lastCostoModified, setLastCostoModified] = useState("costo");
	const [componentes, setComponentes] = useState([
		{
			id: Date.now(),
			componente_id: null,
			notas: "",
			cantidad: 1,
		},
	]);
	const [valoresComponentes, setValoresComponentes] = useState({});
	const [almacenElegido, setAlmacenElegido] = useState(
		producto.almacen ? { value: producto.almacen.id, label: producto.almacen.nombre } : null
	);
	const [ubicacionElegida, setUbicacionElegida] = useState(null);
	// "almacen" | "ubicacion" mientras se crea uno desde su select.
	const [creandoCatalogo, setCreandoCatalogo] = useState(null);

	const crearOpcion = async (catalogo, nombre) => {
		setCreandoCatalogo(catalogo);
		const nueva = catalogo === "almacen" ? await crearAlmacen(nombre) : await crearUbicacion(nombre);
		setCreandoCatalogo(null);

		if (!nueva) return;

		if (catalogo === "almacen") {
			setAlmacenes((prev) => [
				...prev,
				{ id: nueva.value, nombre: nueva.label, tipo_producto: "productos" },
			]);
			setAlmacenElegido(nueva);
		} else {
			setUbicacionElegida(nueva);
		}
	};

	const costoField = useRef(null);

	// El empaque sólo cuenta cuando trae más de una unidad.
	const tieneEmpaque =
		productoType !== "grupo" && Boolean(empaque) && parseFloat(cantidadEmpaque) > 1;

	// El costo se escribe en la unidad elegida, pero el producto guarda el de
	// su unidad base: todo lo demás (costo total enviado, % beneficio de los
	// precios) se calcula sobre el costo base.
	const factorCosto = tieneEmpaque && costoPor === "empaque" ? parseFloat(cantidadEmpaque) : 1;
	const aCostoBase = (valor) => {
		const numero = parseFloat(valor);
		return Number.isFinite(numero) ? Math.round((numero / factorCosto) * 10000) / 10000 : valor;
	};

	useEffect(() => {
		getArbolGrupos();
		getTableData("almacenes");
		getImpuestos();
		getUnidades();
		setInventariable(producto.nombre ? producto.inventariable : true);
	}, []);

	const getArbolGrupos = async () => {
		const respuesta = await request("grupos?arbol=1");
		setArbolGrupos(gruposDeRespuesta(respuesta));
	};

	const getTableData = async (url) => {
		const table = await request(url);
		if (table.data) {
			if (url === "almacenes") setAlmacenes(table.data);
		}
	};

	const getImpuestos = async () => {
		const result = await request("impuestos-dropdown");
		if (result.success) {
			setImpuestos(result.data);
			setImpuestoId(result.data[0].value);
		}
	};

	const getUnidades = async () => {
		const catalogo = await catalogoUnidadesCompleto();
		setUnidades(catalogo);
		// La unidad por defecto (UND) arranca sin id: se enlaza con el catálogo.
		setUnidad((prev) =>
			prev && !prev.id ? catalogo.find((u) => u.value === prev.value) ?? prev : prev
		);
	};

	const createUnidad = async (inputValue) => {
		setIsLoading(true);
		const nuevaUnidad = await crearUnidadConfig(inputValue);
		setIsLoading(false);

		if (nuevaUnidad) {
			setUnidad(nuevaUnidad);
			setUnidades((prev) => [...prev, nuevaUnidad]);
		}
	};

	const createEmpaque = async (inputValue) => {
		setIsLoading(true);
		const nuevaUnidad = await crearUnidadConfig(inputValue);
		setIsLoading(false);

		if (nuevaUnidad) {
			setEmpaque(nuevaUnidad);
			setUnidades((prev) => [...prev, nuevaUnidad]);
		}
	};

	const handleUnidadChange = (newValue) => {
		setUnidad(newValue);
	};

	const handleEmpaqueChange = (newValue) => {
		setEmpaque(newValue);
		if (!newValue) {
			setCantidadEmpaque("");
			setPaquetesIniciales("");
			setCostoPor("unidad");
		}
	};

	// Cantidad inicial = paquetes × cantidad en paquete + unidades sueltas, en
	// unidad base. Vacía si no se escribió nada (el backend la toma como 0).
	const cantidadInicial =
		paquetesIniciales === "" && unidadesIniciales === ""
			? ""
			: Math.round(
					((tieneEmpaque ? (parseFloat(paquetesIniciales) || 0) * parseFloat(cantidadEmpaque) : 0) +
						(parseFloat(unidadesIniciales) || 0)) *
						10000
			  ) / 10000;

	const onChangeInput = (e) => {
		const { name, value } = e.target;

		if (name === "costo_total") {
			setLastCostoModified("costo_total");
			setCostoTotal(value);
			const impuesto = impuestos.find((i) => i.value === parseInt(impuesto_id));
			if (impuesto) {
				setCosto((parseFloat(value) / (impuesto.porcentaje + 1)).toFixed(2));
			}
		} else if (name === "costo") {
			setLastCostoModified("costo");
			setCosto(value);
			const impuesto = impuestos.find((i) => i.value === parseInt(impuesto_id));
			if (impuesto) {
				const parsed = parseFloat(value);
				setCostoTotal((parsed + parsed * impuesto.porcentaje).toFixed(2));
			}
		} else if (name === "impuesto_id") {
			setImpuestoId(value);
			const impuesto = impuestos.find((i) => i.value === parseFloat(value));
			if (impuesto) {
				if (lastCostoModified === "costo") {
					setCostoTotal(
						(parseFloat(costo) + parseFloat(costo) * impuesto.porcentaje).toFixed(2)
					);
				} else {
					setCosto(
						(parseFloat(costo_total) / (impuesto.porcentaje + 1)).toFixed(2)
					);
				}
			}
		} else if (name === "cantidad") {
			setCantidad(value);
		}
	};

	const onChangeCheckbox = (e) => {
		if (e.target.name === "inventariable") {
			setInventariable(e.target.checked);
		}
	};

	const onChangeComponente = (id, value, cantidadComponente, stock) => {
		const disponible = Math.floor(parseFloat(stock) / parseFloat(cantidadComponente));
		const newValues = {
			...valoresComponentes,
			[id]: { value, cantidad: disponible >= 1 ? disponible : 0 },
		};
		setValoresComponentes(newValues);
		onChangeInput({
			target: {
				name: "costo",
				value: Math.ceil(
					Object.values(newValues).reduce((a, b) => a + parseFloat(b.value), 0)
				),
			},
		});
		onChangeInput({
			target: {
				name: "cantidad",
				value: Math.min(...Object.values(newValues).map((v) => v.cantidad)),
			},
		});
	};

	const addPrecio = () => {
		setPreciosVenta((prev) => [
			...prev,
			{
				id: Date.now(),
				precio_venta: 0,
				impuesto: "",
				precio_total: 0,
				costo: 0,
			},
		]);
	};

	const addComponente = () => {
		setComponentes((prev) => [
			...prev,
			{
				id: Date.now(),
				precio_venta: 0,
				impuesto: "",
				precio_total: 0,
				costo: 0,
			},
		]);
	};

	const removePrecio = (id) => {
		setPreciosVenta((prev) => prev.filter((p) => p.id != id));
	};

	const removeComponente = (id) => {
		setComponentes((prev) => prev.filter((c) => c.id != id));
		setValoresComponentes((prev) => {
			const next = { ...prev };
			delete next[id];
			const values = Object.values(next);
			if (values.length > 0) {
				onChangeInput({
					target: {
						name: "costo",
						value: Math.ceil(values.reduce((a, b) => a + parseFloat(b.value), 0)),
					},
				});
				onChangeInput({
					target: {
						name: "cantidad",
						value: Math.min(...values.map((v) => v.cantidad)),
					},
				});
			} else {
				setCosto(0);
				setCostoTotal(0);
				setCantidad(null);
			}
			return next;
		});
	};

	const esProducto = productoType === "producto";
	const unidadBase = unidad?.value || "UND";
	// Con empaque, "Costo por" suma una cuarta columna.
	const columnaCosto = tieneEmpaque ? "col-12 col-sm-4 col-md-3" : "col-12 col-sm-4";
	return (
		<div className="form-secciones">
			<input type="hidden" name="user_id" value={auth.getUser().id} />
			<input type="hidden" name="tipo" value={productoType} />
			<div className="row">
				{/* COLUMNA PRINCIPAL */}
				<div className="col-lg-8">
					<div className="producto-tipos mb-3" role="radiogroup" aria-label="Tipo de producto">
						{TIPOS.map(([valor, etiqueta, icono, descripcion]) => (
							<button
								type="button"
								key={valor}
								role="radio"
								aria-checked={productoType === valor}
								className={`producto-tipo ${
									productoType === valor ? "producto-tipo--activo" : ""
								}`}
								onClick={() => setProductoType(valor)}
							>
								<i className={`${icono} producto-tipo__icono`} aria-hidden="true" />
								<span className="producto-tipo__texto">
									<span className="producto-tipo__nombre">{etiqueta}</span>
									<small className="producto-tipo__descripcion">{descripcion}</small>
								</span>
								{productoType === valor && (
									<i className="fas fa-check-circle producto-tipo__check" aria-hidden="true" />
								)}
							</button>
						))}
					</div>

					<Seccion titulo="Información general" icono="fas fa-info-circle">
						<div className="form-row">
							<div className="form-group col-12 col-md-6">
								<label className="label form-control-label">Nombre:</label>
								<input
									type="text"
									className="text-input form-control"
									id="nombre"
									name="nombre"
									defaultValue={producto.nombre}
								/>
								<ErrorCampo errors={errors} campo="nombre" />
							</div>
							<div className="form-group col-12 col-md-6">
								<label className="label form-control-label">
									Referencia/Código:
								</label>
								<input
									type="text"
									className="text-input form-control"
									id="referencia"
									name="referencia"
									defaultValue={producto.referencia}
								/>
								{errors.referencia && (
									<small className="help-blockParams form-Text">
										Este campo es requerido
									</small>
								)}
							</div>
							<div className={`form-group col-12 ${esProducto ? "col-md-8" : ""}`}>
								<label className="label form-control-label">Descripción:</label>
								<input
									type="text"
									className="text-input form-control"
									id="descripcion"
									name="descripcion"
									defaultValue={producto.descripcion}
								/>
								<ErrorCampo errors={errors} campo="descripcion" />
							</div>
							{esProducto && (
								<div className="form-group col-12 col-md-4">
									<label className="label form-control-label">Estado:</label>
									<select
										className="text-input form-control"
										id="estado"
										name="estado"
										defaultValue={producto.estado}
									>
										<option value="nuevo">Nuevo</option>
										<option value="usado">Usado</option>
									</select>
									<ErrorCampo errors={errors} campo="estado" />
								</div>
							)}
						</div>
					</Seccion>

					<Seccion titulo="Presentaciones" icono="fas fa-box">
						<Presentaciones
							unidades={unidades}
							unidad={unidad}
							empaque={empaque}
							cantidadEmpaque={cantidadEmpaque}
							onChangeUnidad={handleUnidadChange}
							onChangeEmpaque={handleEmpaqueChange}
							onChangeCantidad={setCantidadEmpaque}
							onCreateUnidad={createUnidad}
							onCreateEmpaque={createEmpaque}
							isLoading={isLoading}
							conEmpaque={productoType !== "grupo"}
							errors={errors}
						/>
					</Seccion>

					{productoType === "grupo" && (
						<Seccion
							titulo="Componentes"
							icono="fas fa-cubes"
							extra={
								<button type="button" onClick={addComponente} className="btn btn-link p-0">
									<i className="fas fa-plus" /> Agregar producto
								</button>
							}
						>
							{componentes.map((componente, index) => (
								<Componente
									producto={componente}
									index={index}
									key={componente.id}
									removeComponente={removeComponente}
									accion="crear"
									onChangeComponente={onChangeComponente}
									errors={errors}
								/>
							))}
							<ErrorCampo errors={errors} campo="componentes" />
						</Seccion>
					)}

					<Seccion titulo="Costo" icono="fas fa-coins">
						{/* Lo que se envía es el costo de la unidad base; los precios
						    calculan su % de beneficio sobre este mismo campo. */}
						<input type="hidden" name="costo" ref={costoField} value={aCostoBase(costo)} />
						<input type="hidden" name="costo_total" value={aCostoBase(costo_total)} />
						<div className="form-row">
							{tieneEmpaque && (
								<div className="form-group col-12 col-md-3">
									<label className="label form-control-label">Costo por:</label>
									<select
										className="form-control"
										value={costoPor}
										onChange={(e) => setCostoPor(e.target.value)}
									>
										<option value="unidad">{unidadBase} (unidad)</option>
										<option value="empaque">
											{empaque.value} (x{cantidadEmpaque})
										</option>
									</select>
								</div>
							)}
							<div className={`form-group ${columnaCosto}`}>
								<label className="label form-control-label">
									Costo
									{tieneEmpaque &&
										` por ${costoPor === "empaque" ? empaque.value : unidadBase}`}
									:
								</label>
								<input
									type="number"
									inputMode="decimal"
									className="text-input form-control"
									id="costo"
									step="0.01"
									value={costo}
									onChange={(e) =>
										onChangeInput({ target: { name: "costo", value: e.target.value } })
									}
								/>
							</div>
							<div className={`form-group ${columnaCosto}`}>
								<label className="label form-control-label">Impuesto:</label>
								<select
									className="form-control"
									id="impuesto_id"
									name="impuesto_id"
									value={impuesto_id}
									onChange={onChangeInput}
								>
									{impuestos.map((impuesto) => (
										<option value={impuesto.value} key={impuesto.value}>
											{impuesto.label}
										</option>
									))}
								</select>
							</div>
							<div className={`form-group ${columnaCosto}`}>
								<label className="label form-control-label">Costo total:</label>
								<input
									type="number"
									inputMode="decimal"
									className="text-input form-control"
									id="costo_total"
									step="0.01"
									value={costo_total}
									onChange={(e) =>
										onChangeInput({ target: { name: "costo_total", value: e.target.value } })
									}
								/>
								{factorCosto > 1 && (
									<small className="d-block text-muted">
										= {(parseFloat(aCostoBase(costo_total)) || 0).toFixed(2)} por{" "}
										{unidadBase}
									</small>
								)}
							</div>
						</div>
						{errors.costo && (
							<small className="help-blockParams form-Text">
								El costo debe ser mayor que 0
							</small>
						)}
					</Seccion>

					<Seccion
						titulo="Precios de venta"
						icono="fas fa-tags"
						extra={
							<button
								type="button"
								onClick={addPrecio}
								className="btn btn-link p-0"
							>
								<i className="fas fa-plus" /> Agregar precio
							</button>
						}
					>
						{precios_venta.map((precio, index) => (
							<Precios
								precio={precio}
								precios={precios_venta}
								index={index}
								key={precio.id}
								costo={costoField}
								removePrecio={removePrecio}
								impuestos={impuestos}
								firstTaxSelected={impuesto_id}
								accion="crear"
								errors={errors}
								cantidadEmpaque={tieneEmpaque ? cantidadEmpaque : null}
								etiquetaUnidad={unidadBase}
								etiquetaEmpaque={empaque?.value}
							/>
						))}
						<ErrorCampo errors={errors} campo="precios" />
					</Seccion>
				</div>

				{/* COLUMNA LATERAL */}
				<div className="col-lg-4">
					<Seccion titulo="Inventario" icono="fas fa-warehouse">
						<div className="form-group d-flex align-items-center justify-content-between">
							<label className="label form-control-label mb-0">Inventariable:</label>
							<label className="switch switch-3d switch-success mb-0">
								<input type="hidden" name="inventariable" value="no" />
								<input
									type="checkbox"
									className="switch-input"
									name="inventariable"
									value="yes"
									onChange={onChangeCheckbox}
									defaultChecked={
										producto.id ? producto.inventariable : inventariable
									}
								/>
								<span className="switch-label" />
								<span className="switch-handle" />
							</label>
						</div>
						{!inventariable ? (
							<input type="hidden" name="cantidad" value="" />
						) : productoType === "grupo" ? (
							<div className="form-group">
								<label className="label form-control-label">Cantidad inicial:</label>
								<input
									type="number"
									inputMode="decimal"
									className="text-input form-control"
									id="cantidad"
									name="cantidad"
									step="0.01"
									onChange={onChangeInput}
									value={cantidad ?? ""}
								/>
								<ErrorCampo errors={errors} campo="cantidad" />
							</div>
						) : (
							<div className="form-group">
								<label className="label form-control-label">Cantidad inicial:</label>
								<div className="form-row">
									{tieneEmpaque && (
										<div className="col">
											<small className="text-muted">{empaque.value}</small>
											<input
												type="number"
												min="0"
												step="1"
												inputMode="numeric"
												className="text-input form-control"
												aria-label={`Paquetes (${empaque.value})`}
												value={paquetesIniciales}
												onChange={(e) => setPaquetesIniciales(e.target.value)}
											/>
										</div>
									)}
									<div className="col">
										<small className="text-muted">{unidadBase}</small>
										<input
											type="number"
											min="0"
											step="0.01"
											inputMode="decimal"
											className="text-input form-control"
											aria-label={`Unidades (${unidadBase})`}
											value={unidadesIniciales}
											onChange={(e) => setUnidadesIniciales(e.target.value)}
										/>
									</div>
									<div className="col d-flex align-items-end">
										<span className="pb-2">
											= <strong>{cantidadInicial || 0}</strong> {unidadBase}
										</span>
									</div>
								</div>
								<input type="hidden" name="cantidad" value={cantidadInicial} />
								<ErrorCampo errors={errors} campo="cantidad" />
							</div>
						)}
						{esProducto && (
							<>
								<div className="form-group">
									<label className="label form-control-label">Reorden:</label>
									<input
										type="number"
										name="reorden"
										min="0"
										inputMode="numeric"
										className="form-control"
										defaultValue={producto.reorden}
									/>
									<ErrorCampo errors={errors} campo="reorden" />
								</div>
								<div className="form-group">
									<label className="label form-control-label" htmlFor="almacen_id">
										Almacén:
									</label>
									<input type="hidden" name="almacen_id" value={almacenElegido?.value ?? ""} />
									<CreatableSelect
										inputId="almacen_id"
										options={almacenes
											.filter((a) => a.tipo_producto === "productos")
											.map((a) => ({ value: a.id, label: a.nombre }))}
										value={almacenElegido}
										onChange={setAlmacenElegido}
										onCreateOption={(nombre) => crearOpcion("almacen", nombre)}
										formatCreateLabel={textoCrear}
										isClearable
										isLoading={creandoCatalogo === "almacen"}
										isDisabled={creandoCatalogo === "almacen"}
										placeholder="- Seleccionar -"
										menuPlacement="auto"
									/>
									{errors.almacen_id && (
										<small className="help-blockParams form-Text">
											Este campo es requerido
										</small>
									)}
								</div>
								<div className="form-group">
									<label className="label form-control-label" htmlFor="ubicacion_id">
										Ubicación:
									</label>
									<input type="hidden" name="ubicacion_id" value={ubicacionElegida?.value ?? ""} />
									<AsyncCreatableSelect
										inputId="ubicacion_id"
										cacheOptions
										defaultOptions
										loadOptions={(e) => getUbicacionesForDropdown(e)}
										value={ubicacionElegida}
										onChange={setUbicacionElegida}
										onCreateOption={(nombre) => crearOpcion("ubicacion", nombre)}
										formatCreateLabel={textoCrear}
										isClearable
										isLoading={creandoCatalogo === "ubicacion"}
										isDisabled={creandoCatalogo === "ubicacion"}
										placeholder="- Seleccionar -"
										menuPlacement="auto"
									/>
									{errors.ubicacion_id && (
										<small className="help-blockParams form-Text">
											Este campo es requerido
										</small>
									)}
								</div>
							</>
						)}
					</Seccion>

					<Seccion titulo="Clasificación" icono="fas fa-sitemap">
						{esProducto && (
							<div className="form-group">
								<label className="label form-control-label">Suplidor:</label>
								<SelectAsync
									name="contacto_id"
									cacheOptions
									defaultOptions
									isClearable
									menuPlacement="auto"
									loadOptions={(e) => getSuplidoresForDropdown(e)}
								/>
								<ErrorCampo errors={errors} campo="contacto_id" />
							</div>
						)}
						{/* El árbol se muestra siempre: desde ahí se crea la primera
						    categoría. La primera marcada queda como principal (`grupo`). */}
						<div className="form-group mb-0">
							<label className="label form-control-label">Categorías:</label>
							<CategoriasCheckboxTree
								arbol={arbolGrupos}
								valor={categorias}
								onChange={setCategorias}
								recargarArbol={getArbolGrupos}
								nombreCampo="categorias[]"
							/>
							<ErrorCampo errors={errors} campo="categorias" />
						</div>
					</Seccion>

					{(esProducto || productoType === "grupo") && (
						<Seccion titulo="Fotos" icono="fas fa-images">
							<ImageLoader name="fotos[]" multiple />
							<ErrorCampo errors={errors} campo="fotos" />
						</Seccion>
					)}
				</div>
			</div>
		</div>
	);
};

export default withRequest(Form);
